import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-photo',
  templateUrl: './account-photo.component.html',
  styleUrls: ['./account-photo.component.css'],
})
export class AccountPhotoComponent implements OnInit {
  @Input() name!: string;
  @Input() disabled: boolean = false;

  initials: string = '';

  constructor() {}

  ngOnInit(): void {
    let split = this.name.split(' ');
    let first = split[0].trim()[0];
    this.initials = first;
  }
}
